/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Sections Data
 */

// Containers
import About from '../containers/sections/About';
import Contact from '../containers/sections/Contact';
import Photos from '../containers/sections/Photos';
import Rooms from '../containers/sections/Rooms';
import Services from '../containers/sections/Services';
import TheHouse from '../containers/sections/TheHouse';
import ToVisit from '../containers/sections/ToVisit';

// Data
import { ABOUT } from './About';
import { CONTACT } from './Contact';
import { PHOTOS } from './Photos';
import { ROOMS } from './Rooms';
import { SERVICES } from './Services';
import { THEHOUSE } from './TheHouse';
import { TOVISIT } from './ToVisit';

export const SECTIONS = {
    thehouse: {
        id: 'thehouse',
        className: 'page-section--pb-0',
        sectionHeader: {
            title: 'A Casa',
            text: 'O Encontro Mais Doce com a Natureza!',
        },
        component: <TheHouse thehouse={THEHOUSE} />,
    },
    services: {
        id: 'services',
        className: 'page-section',
        sectionHeader: {
            title: 'Os Nossos Serviços',
            text: 'O que lhe propomos!',
        },
        component: <Services services={SERVICES} />
    },
    about: {
        id: 'about',
        className: 'page-section--bg-image',
        sectionOverlay: true,
        sectionHeader: {
            title: 'Sobre Nós'
        },
        component: <About about={ABOUT} />
    },
    rooms: {
        id: 'rooms',
        className: 'page-section',
        sectionHeader: {
            title: 'Quartos',
            text: 'Na companhia das montanhas, embarque numa viagem fascinante ao mundo das abelhas...',
        },
        component: <Rooms rooms={ROOMS} />
    },
    tovisit: {
        id: 'tovisit',
        className: 'page-section--gold',
        sectionHeader: {
            title: 'Onde Estamos'
        },
        component: <ToVisit tovisit={TOVISIT} />
    },
    photos: {
        id: 'photos',
        className: 'page-section',
        sectionHeader: {
            title: 'A Nossa Galeria',
            text: 'As Fotos dos Espaços e Meios Envolventes!',
        },
        component: <Photos images={PHOTOS} limit={8} />
    },
    contact: {
        id: 'contact',
        className: 'page-section',
        sectionHeader: {
            title: 'Contacte-nos',
            text: <>Pronto para uma experiência inesquecível? <br />Envie-nos a sua mensagem e entraremos em contacto tão rápido quanto possível!</>,
        },
        component: <Contact contact={CONTACT} />
    }
}